<section class="mahaagx-dpi" aria-labelledby="mahaagx-dpi-title">
  <div class="mahaagx-dpi--container">
    <div class="mahaagx-dpi--header">
      <span class="mahaagx-dpi--accent" aria-hidden="true"></span>
      <h2 id="mahaagx-dpi-title" class="mahaagx-dpi--title">MahaAgX as a Digital Public Infrastructure</h2>
      <span class="mahaagx-dpi--line" aria-hidden="true"></span>
    </div>

    <p class="mahaagx-dpi--intro">
      Designed in alignment with the India Digital Ecosystem Architecture (INDEA), the national reference framework for building scalable and interoperable Digital Public Infrastructures.
    </p>

    <div class="mahaagx-dpi--card">
      @for (card of cards; track card.id) {
        <div class="dpi-card--row">
          <div class="dpi-card--icon">
            <img [src]="card.icon" [alt]="card.title" class="dpi-card--icon-img" />
          </div>
          <div class="dpi-card--content">
            <h3 class="dpi-card--title">{{ card.title }}</h3>
            <p class="dpi-card--description">{{ card.description }}</p>
          </div>
        </div>
      }
    </div>
  </div>
</section>
